import { ArrowLeft } from "lucide-react";
import { Link } from "react-router";
import { useSession } from "@/lib/auth-client";

export function LegalBackLink() {
  const { data: session } = useSession();
  const target = session ? "/" : "/login";
  const label = session ? "Back to home" : "Back to login";

  return (
    <Link
      to={target}
      className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground"
    >
      <ArrowLeft className="h-3.5 w-3.5" />
      {label}
    </Link>
  );
}
